import { render, staticRenderFns } from "./ImportLeavesFailed.vue?vue&type=template&id=a0cc30c4"
import script from "./ImportLeavesFailed.vue?vue&type=script&lang=js"
export * from "./ImportLeavesFailed.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports